import { getBackgroundColors, getBrandColors } from '../utils/color';

export const defaultColors = {
  brand: {
    300: '#497CFD',
    400: '#356EFD',
    500: '#2160FD',
    600: '#0D51FD',
    700: '#2160FD',
  },
  background: {
    1000: '#080808',
    900: '#1A1A1A',
    800: '#333333',
    700: '#4C4C4C',
    600: '#666666',
  },
  text: '#FFFFFF',
  textOnBrand: '#FFFFFF',
  videoBg: '#333333',
  success: '#83D017',
  danger: '#FF2D2D',
  warning: '#FFCD07',
};

/**
 * Function which adds support for adding any opacity value to colors from CSS Variables
 * @param {string} varName The CSS variable name of the color
 * @param {string} color The color code in Hex
 * @param {number} opacityValue The opacity value - [0,100]
 * @returns Parsed string to be used in Tailwind CSS config
 */
export const generateBackgroundColors = (color) => {
  return getBackgroundColors(color);
};

export const generateBrandColors = (color) => {
  return getBrandColors(color);
};
